import { getBrowserVersion } from '../actions/util';
/*
 * @Date: 2023-02-27 03:01:31
 * @LastEditors: simLarry
 * @LastEditTime: 2023-04-25 23:52:07
 * @FilePath: \F1-M3-QRP-CODE\config\Host.config.js
 */
let Config = {};

export const STAGE_HOST_URL_API  = 'https://febff-api-staging-m3.fun88.biz';
// export const HOST_URL_API        = 'https://febff-api-m3.fun88.biz';
export const SL_HOST_URL_API     =  STAGE_HOST_URL_API

export const STAGE_ENPOINT_URL = 'https://qrpstagingfun88.gamealiyun.com';
export const ENPOINT_URL = 'https://qrpfun88.gamealiyun.com';


// 判断环境
if ( typeof global.location !== 'undefined' ){
	let parsed = Domainparse(window.location.host);
	let LocalHost = global.location.host;
	let isHttps = 'https:' === document.location.protocol;
	let isLocal = Boolean(
        [
            "localhost:8889",
        ].find((v) => global.location.host.includes(v))
    );
	let SLAPI = Boolean(
		[
			'qrpm3sl',
			// 'localhost:8889'
		].find((v)=>global.location.href.includes(v))
	)
	
	// 测试环境
	let StagingAPI = Boolean(
		[
			'qrpm3stag',
			'127.0.0.1:8889',
			'localhost:8889'
		].find((v)=>global.location.href.includes(v))
	)
	if( StagingAPI ){
		
		Config = {
			HostApi   : STAGE_HOST_URL_API,
			LocalHost : '',
			CMSURL    : isLocal ? `https://cache.p5stag.fun88.biz` : `https://cache.${LocalHost}`, 
			ENDPOINT  : STAGE_ENPOINT_URL,
			CSPURL:`https://f1cspstg.fun88.biz/?fromUrl=<# Domain #>&language=vn&platform=${getBrowserVersion() === 8 ? "Mobile" : "Web"}`
		}
	}else if(SLAPI){
		// 判断是否在master 分支
		
		Config = {
			HostApi   : SL_HOST_URL_API,
			LocalHost : '',
			CMSURL    : isLocal ? `https://cache.p5sl.fun88.biz` : `https://cache.${LocalHost}`, 
			ENDPOINT  : ENPOINT_URL,
			CSPURL:""
		}
	}else{
		// 判断是否在SL 
		// if ( LocalHost === '' )
		
		Config = {
			/* 灰度地址 */
			HostApi: `https://gatewayvn-scf1.${parsed.sld}.${parsed.tld}`,
			LocalHost: (isHttps ? 'https://' : 'http://') + LocalHost + '/',
			CMSURL: `https://cache.${(global.location.host).replace("www.", "")}`,
			CSPURL:`https://csp.<# Domain0 #>/?fromUrl=<# Domain #>&language=vn&platform=${getBrowserVersion() === 8 ? "Mobile" : "Web"}`
		};
		
	}
		

} 

/**
 * @description: 获取二级域名 转换动态api 域名
 * @param {*} input 完整域名
 * @return {*}
 */
function Domainparse(input) {
	if (typeof input !== 'string') {
		throw new TypeError('Domain name must be a string.');
	}
	// Force domain to lowercase.
	var domain = input.slice(0).toLowerCase();
	// Handle FQDN.
	// TODO: Simply remove trailing dot?
	if (domain.charAt(domain.length - 1) === '.') {
		domain = domain.slice(0, domain.length - 1);
	}
	var parsed = {
		input: input,
		tld: null,
		sld: null,
		domain: null,
		subdomain: null,
		listed: false
	};
	var domainParts = domain.split('.');
	// Non-Internet TLD
	if (domainParts[domainParts.length - 1] === 'local') {
		return parsed;
	}
	var handlePunycode = function() {
		if (!/xn--/.test(domain)) {
			return parsed;
		}
		if (parsed.domain) {
			parsed.domain = Punycode.toASCII(parsed.domain);
		}
		if (parsed.subdomain) {
			parsed.subdomain = Punycode.toASCII(parsed.subdomain);
		}
		return parsed;
	};
	var rule = null;
	// Unlisted tld.
	if (!rule) {
		if (domainParts.length < 2) {
			return parsed;
		}
		parsed.tld = domainParts.pop();
		parsed.sld = domainParts.pop();
		parsed.domain = [ parsed.sld, parsed.tld ].join('.');
		if (domainParts.length) {
			parsed.subdomain = domainParts.pop();
		}
		return handlePunycode();
	}
	// At this point we know the public suffix is listed.
	parsed.listed = true;

	var tldParts = rule.suffix.split('.');
	var privateParts = domainParts.slice(0, domainParts.length - tldParts.length);

	if (rule.exception) {
		privateParts.push(tldParts.shift());
	}
	parsed.tld = tldParts.join('.');
	if (!privateParts.length) {
		return handlePunycode();
	}
	if (rule.wildcard) {
		tldParts.unshift(privateParts.pop());
		parsed.tld = tldParts.join('.');
	}

	if (!privateParts.length) {
		return handlePunycode();
	}
	parsed.sld = privateParts.pop();
	parsed.domain = [ parsed.sld, parsed.tld ].join('.');
	if (privateParts.length) {
		parsed.subdomain = privateParts.join('.');
	}
	return handlePunycode();
}

export default { Config, Domainparse };
